import type { KarlCustomPayload } from "@/components/document-chat/services/streamEventTypes";
import { KarlEventContent, ProcessingNode, StreamPhase } from "@/constants/enums";
// Types are globally available from @/types/chat-sse.d.ts
import type { DocumentChatRuntime } from "../types";

/**
 * Handles REASONING events for thinking phase control
 *
 * @param payload - The reasoning event payload
 * @param session - The current stream session
 * @param runtime - The document chat runtime store interface
 */
export function handleReasoningEvent(
  payload: KarlCustomPayload,
  session: StreamSession,
  runtime: DocumentChatRuntime
): void {
  const c = String(payload.content ?? "").toUpperCase();

  if (c === KarlEventContent.START) {
    runtime.update({ phase: StreamPhase.THINKING, currentNode: ProcessingNode.QUESTION_GENERATOR });
    session.thinkingActive = true;
    runtime.markThinkingStart();
  } else if (c === KarlEventContent.FINISHED) {
    session.thinkingActive = false;
    // Don't reset currentNode - keep it at QuestionGenerator so UI stays visible
    // until the next stage (ContextRetriever) starts
  }
}
